import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import SideNavbar from "./SideNavbar";
import Header from "./Header";
import { Cache } from "aws-amplify";

import Dashboard from "../dashboard/Dashboard";

import {
  getWeeksInYear,
  toggleShowAlert,
} from "../../store/actions/commonActions";

import UpsertPosts from "../posts/UpsertPost";
import Login from "../Login";
import Posts from "../posts/Posts";
import PermissionsForm from "../settings/permissions/PermissionsForm";
import Permissions from "../settings/permissions/Permissions";
import Company from "../settings/company/Company";
import CompanyForm from "../settings/company/CompanyForm";
import AsuiteApps from "../settings/asuite_apps/AsuiteApps";
import AsuiteAppForm from "../settings/asuite_apps/AsuiteAppForm";
import MobileAppBanners from "../settings/mobileappbanners/MobileAppBanner";
import MobileAppBannerForm from "../settings/mobileappbanners/MobileAppBannerForm";
import SplashScreens from "../settings/splashscreens/SplashScreens";
import SplashScreenForm from "../settings/splashscreens/SplashScreenForm";
import UsageStatistics from "../reports/usage_statistics/UsageStatistics";
import Users from "../settings/users/AdminUsers";
import AppVersions from "../settings/appversions/AppVersions";
import AppVersionsForm from "../settings/appversions/AppVersionsForm";

import PrivacyPolicy from "../posts/PrivacyPolicy";
import Terms from "../posts/Terms";
import FAQs from "../posts/FAQs";
import SendNotification from "../notifications/SendNotification";
import UserForm from "../settings/users/AdminUserForm";
import {
  COMPANY_ADMIN,
  SUPER_ADMIN,
} from "../../store/actions/users/usersActions";

import { AlertMessage } from "../../common/Utilities";
import {
  checkIsUpdated,
  redirectToLogin,
  setUserData,
} from "../../store/actions/auth/authActions";
import Authenticator from "../auth/Authenticator";

const Main = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const authToken = Cache.getItem("token");
  const clickedURL = "clickedURL";

  useEffect(() => {
    if (!authToken) {
      Cache.setItem(
        clickedURL,
        props.location.pathname + props.location.search
      );
      redirectToLogin();
    } else if (Cache.getItem(clickedURL)) {
      props.history.push(Cache.getItem(clickedURL));
      Cache.removeItem(clickedURL);
    }
  }, [authToken]);

  useEffect(async () => {
    await setUserData();
    const userData = Cache.getItem("userdata");

    if (userData && userData.userDetails !== null) {
      // checkIsUpdated().then((response) => {
      //   if (!response) {
      //     setUserData().then(() => {
      //       setIsLoading(false);
      //     });
      //   } else {
      //     setIsLoading(false);
      //   }
      // });

      if (userData?.userDetails?.is_disabled === 1) {
        redirectToLogin();
        localStorage.clear();
        Cache.clear();
        props.toggleShowAlert(
          true,
          "danger",
          "User is disabled. Please contact the WeAreAyala Administrator."
        );
        setIsLoading(false);
      } else if (SUPER_ADMIN !== userData?.userDetails?.roles[0]?.id) {
        redirectToLogin();
        localStorage.clear();
        Cache.clear();
        props.toggleShowAlert(
          true,
          "danger",
          "Unauthorized Access. Please contact the WeAreAyala Administrator."
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, [props.location.pathname]);

  const switchContent = () => {
    const pathname = props.location.pathname;
    switch (pathname) {
      case "/dashboard":
        return <Dashboard />;
      case "/login":
        return <Login />;
      case "/posts":
        return <Posts />;
      case "/posts/new":
      case "/posts/edit":
      case "/posts/view":
        return <UpsertPosts />;
      case "/terms/edit":
        return <Terms />;
      case "/privacy-policy/edit":
        return <PrivacyPolicy />;
      case "/faqs/edit":
        return <FAQs />;
      case "/send-notification":
        return <SendNotification />;
      case "/reports/usage-statistics":
        return <UsageStatistics />;
      case "/settings/admins":
      case "/settings/admins/disabled":
        return <Users />;
      case "/settings/admins/new":
      case "/settings/admins/edit":
        return <UserForm />;
      case "/settings/roles-permissions":
        return <Permissions />;
      case "/settings/roles-permissions/new":
      case "/settings/roles-permissions/edit":
        return <PermissionsForm />;
      case "/settings/company":
        return <Company />;
      case "/settings/company/add":
        return <CompanyForm />;
      case "/asuite-apps":
        return <AsuiteApps />;
      case "/asuite-apps/new":
      case "/asuite-apps/edit":
        return <AsuiteAppForm />;
      case "/splash-screens":
        return <SplashScreens />;
      case "/splash-screens/new":
      case "/splash-screens/edit":
        return <SplashScreenForm />;
      case "/mobile-app-banner":
        return <MobileAppBanners />;
      case "/mobile-app-banner/new":
      case "/mobile-app-banner/edit":
        return <MobileAppBannerForm />;
      case "/app-versions":
        return <AppVersions />;
      case "/app-versions/new":
        return <AppVersionsForm />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spinner animation="border" size="lg" />
        </div>
      ) : (
        <>
          <Container fluid id="t3-main-container">
            <Row>
              <Col sm={12} md={3} lg={2} id="t3-main-side-nav-left">
                <SideNavbar />
              </Col>
              <Col xs={10} sm={10} md={10} lg={10} xl={10} id="t3-main-content">
                <Header />
                <Row className="align-left">
                  <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                    {switchContent()}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getWeeksInYear: () => dispatch(getWeeksInYear()),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
